import "./App.css";
import { Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { createBrowserHistory } from "history";
import theme from "./theme";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./assets/scss/index.scss";
import Header from "./components/Header";
import Footer from "./components/Footer";
import React, { Suspense } from "react";
import LocationPage from "views/locationPage";
const FaceMatchIPV = React.lazy(() => import("./views/FaceMatch/FaceMatchIPV"));
const FaceCapture = React.lazy(() => import("./views/FaceCapture"));
const ErrorView = React.lazy(() => import("./views/Error/Error"));
const NotFoundView = React.lazy(() => import("./views/NotFound/NotFound"));

const browserHistory = createBrowserHistory();

function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ThemeProvider theme={theme}>
        <Header />

        <Routes history={browserHistory}>
          {/* <Route
						element={<FaceMatchIPV />}
						exact
						path="/pms/:orgId/:refId/candidate"
					/> */}
          <Route
            element={<FaceCapture />}
            exact
            path="/pms/:orgId/:refId/candidate"
          />
          <Route element={<LocationPage />} exact path="/location" />
          <Route element={<ErrorView />} exact path="/error" />
          <Route element={<NotFoundView />} path="*" />
        </Routes>
        <Footer />
      </ThemeProvider>
    </Suspense>
  );
}

export default App;
